import React from "react";
import entry_translations from "./entry.translations";
import MapV1 from "src/components/mapbox/map.v1";
import { ApplicationContext } from "src/context";
import { getLatitude, getLongitude } from "src/utils/location";

/**
 * Displays map from entry:
 */
export default class EntryLocationMap extends React.Component<{ entry: TEntry }> {

    /** @ts-ignore-next */
    public context!: React.ContextType<typeof ApplicationContext>;
    static contextType = ApplicationContext;

    render(): React.ReactNode {
        const location = this.props.entry.location;
        if (!location) return null;

        const latitude = getLatitude(location);
        const longitude = getLongitude(location);

        return <section className="my-6">
            <div className="generalTextBold mb-2"> {this.context.translate(entry_translations, 'location_label')} </div>
            <p className="generalText mb-6">{this.context.translate(location?.main_translations, 'body', true, true)}</p>
            {location?.address ? <p className="generalText mb-6">{location?.address}</p> : null}
            {latitude && longitude ? <MapV1
                latitude={latitude}
                longitude={longitude}
                zoom={13}
                showLocationMarker
                disableInteractivity
                openModalMapOnClick
            /> : null}
        </section>
    }
}